import { gql } from '@apollo/client';

export const GET_PROFILE = gql`
  query Profile {
    profile {
      status
      code
      error
      data {
        id
        name
        time_zone
        time_zone_automatic
        language
        language_automatic
        email
        brand_id
        email_enabled
        role
        phone
        profile_picture
        permissions
        subrole
        platforms {
          id
          name
          url
        }
      }
    }
  }
`;
export const GET_PROFILE_NOTIFICATION = gql`
  query ProfileNotifications {
    profileNotifications {
      status
      code
      error
      data {
        id
        notifications {
          type
          app
          email
          push
        }
      }
    }
  }
`;

export const GET_USERS = gql`
  query Users(
    $name: String
    $role: String
    $offset: Int
    $platforms: [String]
    $limit: Int
    $orderBy: String
    $orderDirection: String
    $brand_id: String
  ) {
    users(
      name: $name
      role: $role
      offset: $offset
      platforms: $platforms
      limit: $limit
      orderBy: $orderBy
      orderDirection: $orderDirection
      brand_id: $brand_id
    ) {
      status
      code
      error
      count
      data {
        id
        name
        email
        role
        subrole
        profile_picture
        ppt_name
        createdAt
        exclusivity
        platforms {
          name
          url
        }
      }
    }
  }
`;

export const GET_SINGLE_USER = gql`
  query User($id: String!) {
    user(userId: $id) {
      status
      code
      error
      data {
        id
        name
        email
        time_zone
        time_zone_automatic
        language
        language_automatic
        role
        phone
        profile_picture
        blocked
        last_login
        subrole
        holdedIdSpain
        holdedIdAndorra
        ppt_name
        exclusivity
        platforms {
          id
          name
          url
        }
      }
    }
  }
`;
